module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sfboxl2"
  }, [_c('div', {
    staticClass: "wfull"
  }, [_c('div', {
    staticClass: "hotfbox"
  }, [_c('div', {
    staticClass: "after-sales-wfull-left1",
    attrs: {
      "id": "contentbox"
    }
  }, [_c('div', {
    staticClass: "details-head"
  }, [_c('div', {
    staticClass: "details-title"
  }, [_c('p', [_vm._v("公司介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "terartboto"
  }, [_vm._v("您所在的位置：关于我们 > "), _c('a', {
    attrs: {
      "href": "javascript:void",
      "rel": "category tag"
    }
  }, [_vm._v("关于企业")]), _vm._v(" > 公司介绍")])]), _vm._v(" "), _c('div', {
    staticClass: "datails-content"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-indent": "2em"
    }
  }, [_vm._v("\n奇克（上海）实业有限公司创立于2014年，由专业的销售团队，提供进口化工原料及塑料加工助剂的销售和支持。致力于高性能的塑料改性和特种塑料改性行业。\n本公司先后取得韩国KC公司中国大陆地区电缆料市场代理权和韩国全景化学公司在中国大陆地区代理权等。销售的氢氧化铝、氢氧化镁阻燃剂、粉末丁腈橡胶、硅酮塑料加工助剂等产品在市场领域得到了很好的应用，广泛受到了客户的好评。在新老客户的大力支持下，我们赋予最稳定的产品和优质的服务于客户，相信我们将以最诚挚的服务，优惠的价格，与您共创双赢！\n\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "datails-foot"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-907ed730"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 203
// module chunks = 1